<template>
  <span class="page-module">
    <span
      class="price-text">可用余额：{{ priceData.accountCouponAmt }}元  冻结约：{{ priceData.accountCouponFrozenAmt }}元</span>
    <a-button @click="dialogVisible = true">充值</a-button>
    <a-modal title="充值" :visible="dialogVisible" width="880px" :footer="null" @cancel="handleCancel">
      <a-row>
        <a-col :span="9">
          <detail-list :col="1" title="充值收款银行账户">
            <detail-list-item term="户名">{{ bankInfo.bankMan }}</detail-list-item>
            <detail-list-item term="账号">{{ bankInfo.bankAccount }}</detail-list-item>
            <detail-list-item term="开户行">{{ bankInfo.bankName }}</detail-list-item>
          </detail-list>
        </a-col>
        <a-col :span="15">
          <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol"
                        :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="充值金额" prop="amount">
              <a-input v-model="ruleForm.amount" prefix="￥" suffix="RMB" placeholder="请输入充值金额" :maxLength="14"/>
            </a-form-model-item>
            <a-form-model-item label="转账电子回单" style="margin-bottom:0px" required>
              <a-upload
                name="avatar"
                listType="picture-card"
                :fileList="fileList"
                :action="uploadFileUrl"
                :beforeUpload="beforeUpload"
                @preview="handlePreview"
                @change="handleChange"
                :remove="handleRemove"
              >
                <div v-if="fileList.length < 4">
                  <a-icon type="plus"/>
                  <div class="ant-upload-text">Upload</div>
                </div>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handleImgCancel">
                  <img alt="example" style="width: 100%" :src="previewImage"/>
                </a-modal>
              </a-upload>
            </a-form-model-item>
            <a-form-model-item label="转账备注">
              <a-textarea v-model="ruleForm.largeUserMessage" placeholder="转账备注，如转账人姓名、卡号、银行" :rows="3"
                          :maxLength="140"/>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
              <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
		</a-modal>
  </span>
</template>

<script>
export default {
  name: 'CustomRecharge',
  data() {
    return {
      merchantId: this.$store.getters.userInfo.merchantId,
      priceData: {
        accountCouponAmt: 0,
        accountCouponFrozenAmt: 0
      },
      previewImage: '',
      previewVisible: false,
      fileList: [],
      dialogVisible: false,
      bankInfo: '',
      uploadFileUrl: this.getUploadFileUrl(),
      submitLoading: false,
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      ruleForm: {
        amount: 0,//充值多少钱
        largeOrderImg: '',
        largeOrderNo: '',
        largePayType: 3,//充值
        largeUserId: this.$store.getters.userInfo.merchantId,
        largeUserMessage: ''
      },
      imgUploadList: [],
      rules: {
        amount: [
          { required: true, message: '请输入充值金额', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,7}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getMerchantCouponAccount()
    this.getBankInfo()
  },
  methods: {
    //获取图片上传地址
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    handleImgCancel() {
      this.previewVisible = false
    },
    handleCancel() {
      this.dialogVisible = false
    },
    // 获取金额
    getMerchantCouponAccount() {
      this.getHttpServices().getUserService().get('user/coupon/getMerchantCouponAccount/' + this.merchantId).then(res => {
        this.getLogUtils().logWithTag('==getMerchantCouponAccount==', res)
        this.priceData = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getBankInfo() {
      this.getHttpServices().getOrderService().post('largePayment/getBankInfoVo').then(res => {
        this.getLogUtils().logWithTag('==getBankInfo==', res)
        this.bankInfo = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.getUploadImageList()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.ruleForm.largeOrderImg = this.imgUploadList.join(',')
      this.getHttpServices().getOrderService().post('largePayment/orderPaySubmit', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('保存成功')
        this.dialogVisible = false
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 图片上传
    handleChange({ fileList }) {
      this.getLogUtils().logWithTag('handleChange', fileList)
      this.fileList = fileList
    },
    handleRemove(file) {
      this.getLogUtils().logWithTag('handleRemove', file)
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.getLogUtils().logWithTag('handleRemove==this.fileList', this.fileList)
    },
    async handlePreview(file) {
      this.getLogUtils().logWithTag('handlePreview', file)
      this.previewImage = file.response.data
      this.previewVisible = true
    },
    beforeUpload(file) {
      this.getLogUtils().logWithTag('beforeUpload', file)
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isGIF = file.type === 'image/gif'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isGIF || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、GIF、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于1M!')
        return false
      }
      return true
    },
    getUploadImageList() {
      let arr = []
      this.fileList.forEach((item) => {
        arr.push(item.response.data)
      })
      this.imgUploadList = arr
      this.getLogUtils().logWithTag('handleChange===imgUploadList', this.imgUploadList)
      if (this.imgUploadList.length < 1) {
        this.$message.error('上传银行转账电子回单')
        return false
      }
      return true
    }
  }

}
</script>
<style lang="less" scoped>

</style>